// extracted by mini-css-extract-plugin
export default {"container":"book-appointment_container__0vVaa"};